module.exports = __webpack_public_path__ + "static/media/TP2.6f76c0c9.jpg";